import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, get, find } from 'lodash';
import { initAuth } from '../../app-main/actions/auth';
import { fetchContractsSnapshot } from '../../app-main/actions/contracts';
import { fetchBooking } from '../../app-main/actions/booking';
import { ReviewGuestUpdateMain } from '../../app-bookings-update/ReviewGuestUpdateMain';
import { normalizeContracts, priceBreakdownObject } from '../../app-bookings-request/forms/bookingUtil';
import { fetchPayment } from '../actions/payment';

class ReviewUpdateContainer extends Component {
  componentDidMount () {
    if (this.props.accessToken) {
      const { dispatch, routeParams, accessToken, bookingID, profile, payment } = this.props;

      if (isEmpty(profile.data)) {
        dispatch(initAuth(accessToken));
      }

      // although the ids are the same number, naming them differently
      // helps us avoid parsing the urls
      const offerBookingID = _.get(routeParams, 'id');
      const acceptBookingID = _.get(routeParams, 'bookingID');

      dispatch(fetchContractsSnapshot(offerBookingID || acceptBookingID || bookingID, accessToken, (response) => {
        if (isEmpty(get(response, 'contract.data.contracts'))) {
          dispatch(fetchBooking(offerBookingID || acceptBookingID || bookingID, accessToken));
        }
      }));

      if (!payment?.hasFetched) {
        const ssoId = PSSessions.Cookies('PSUser');
        dispatch(fetchPayment(acceptBookingID, accessToken, ssoId));
      }
    }
  }

  componentWillReceiveProps (nextProps) {
    const { accessToken } = nextProps;

    // if user logs out, redirect to sign in
    if (!accessToken) {
      window.location.href = '/';
    }
  }

  render () {
    const { contract, booking } = this.props;
    const spaceRental = find(get(contract, 'data.contracts'), { type: 'SPACE_RENTAL' });
    const normalizedPendingContracts = normalizeContracts(get(contract, 'data.pending', []), spaceRental);
    const normalizedCurrentContracts = normalizeContracts(get(contract, 'data.contracts', []));
    const currency = get(
      normalizedPendingContracts,
      'spaceRentalContract.meta.listing.prices[0].currency', 'USD'
    );

    return (
      <div>
        {
          !isEmpty(get(contract, 'data.contracts')) || !isEmpty(get(booking, 'booking'))
            ? <ReviewGuestUpdateMain
              {...this.props}
              booking={normalizedPendingContracts.bookingObject}
              hostId={normalizedPendingContracts.bookingObject.host_id}
              guestId={normalizedPendingContracts.bookingObject.guest_id}
              currency={currency}
              pendingContracts={normalizedPendingContracts}
              currentContracts={normalizedCurrentContracts}
            />
            : null
        }
      </div>
    );
  }
}

ReviewUpdateContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired
};

function mapStateToProps (state) {
  const { auth, profile, booking, contract, payment } = state;

  const {
    isFetching
  } = profile || {
    isFetching: true
  };

  const normalizedContracts = normalizeContracts(
    get(contract, 'data.pending', []),
    find(get(contract, 'data.pending'), { type: 'SPACE_RENTAL' })
  );
  const priceBreakdown = priceBreakdownObject(normalizedContracts);
  const updateDifference = get(priceBreakdown, 'updateDifference', {});
  const refund = get(updateDifference, 'refund', 0);
  const additionalPayment = get(updateDifference, 'additional_payment', 0);
  const priceDiff = refund ? refund * -1 : additionalPayment;

  return {
    auth,
    profile,
    isFetching,
    booking,
    contract,
    payment,
    refund,
    additionalPayment,
    priceDiff
  };
}

export default connect(mapStateToProps)(ReviewUpdateContainer);
